// extracted by mini-css-extract-plugin
export default {"notFoundContent":"select-label_notFoundContent__s4nPx","labelWrapper":"select-label_labelWrapper__lCZjV","labelName":"select-label_labelName__VVC7l"};